"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
require("./ImageIcon.scss");
var _constants = require("global-components-library/dist/util/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ImageIcon = function ImageIcon(_ref) {
  var id = _ref.id,
    type = _ref.type,
    image = _ref.image,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "" : _ref$name,
    icon = _ref.icon,
    _ref$showTooltip = _ref.showTooltip,
    showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMissing = _useState2[0],
    setIsMissing = _useState2[1];
  var handleError = function handleError() {
    return setIsMissing(true);
  };
  var idHolder = id || (name && showTooltip ? 'uin-iic-' + name.replace(/\s+/g, '') : undefined);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-image-icon ".concat(type ? 'outbound' : 'inbound', " ").concat(icon ? 'icon' : ''),
    id: idHolder
  }, icon ? /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + icon
  }) : !isMissing && image > 0 && typeof _constants.CAMPAIGN_ICONS[image - 1] !== 'undefined' ? /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + _constants.CAMPAIGN_ICONS[image - 1].icon
  }) : /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon anchor"
  }), name && showTooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: idHolder,
    boundariesElement: "window"
  }, name));
};
ImageIcon.propTypes = {
  id: _propTypes["default"].string,
  type: _propTypes["default"].number,
  image: _propTypes["default"].number,
  name: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  showTooltip: _propTypes["default"].bool
};
var _default = exports["default"] = ImageIcon;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/ImageIcon/ImageIcon.js
// module id = 167
// module chunks = 0